var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"Rechteck-2280 tw-text-sm tw-p-4 inline-block align-middle"},[_c('input',{attrs:{"type":_vm.type,"name":_vm.name,"id":_vm.name}}),_vm._v(" "),_c('label',{staticClass:"form-switch-label",attrs:{"for":_vm.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }